import Vue from 'vue'
import VueRouter from 'vue-router'

import Vuex from 'vuex'
import store from './store/'
import axios from 'axios'
import VueAxios from 'vue-axios'

import App from './App'

import router from './router'

Vue.config.productionTip = false

axios.interceptors.request.use(config => {
  store.commit('setLoader', true)
  return config
});

axios.interceptors.response.use(response => {
  setTimeout(() => { store.commit('setLoader', false) }, 1000)
  return response
})


Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(VueAxios, axios)


// Steps autoload
var _ = require('lodash');
var steps = {};
const files = require.context('./components/steps/', true, /\.vue$/i)
files.keys().map(key => {
  const name = 'step' + _.last(key.split('/')).split('.')[0];
  steps[name] = files(key).default;
  return Vue.component(name, files(key).default);
});
// substeps Autoload
var subSteps = {};
const subfiles = require.context('./components/substeps/', true, /\.vue$/i)
subfiles.keys().map(key => {
  const name = 'substep' + _.last(key.split('/')).split('.')[0];
  subSteps[name] = subfiles(key).default;
  return Vue.component(name, subfiles(key).default);
});


import {
  mapActions
} from 'vuex'

new Vue({
  router,
  render: h => h(App),
  mounted() {
    this.$store.commit('setStepsCount', _.size(steps)-1)
  },
  store
}).$mount('#app')
